import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, FileText, Bell, User } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';

const tabs = [
    { to: '/', label: 'Trang chủ', icon: Home },
    { to: '/notes', label: 'Ghi Chú', icon: FileText },
    { to: '/notifications', label: 'Thông Báo', icon: Bell },
];

const MobileTabBar: React.FC = () => {
    const { isAuthenticated, user, openAuthModal } = useAuthStore();

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg safe-area-bottom">
            <div className="flex items-center justify-around h-16">
                {tabs.map((tab) => (
                    <NavLink
                        key={tab.to}
                        to={tab.to}
                        className={({ isActive }) =>
                            `flex flex-col items-center justify-center flex-1 h-full py-2 transition-colors
                            ${isActive
                                ? 'text-blue-600'
                                : 'text-gray-500 hover:text-gray-700'
                            }`
                        }
                    >
                        {({ isActive }) => (
                            <>
                                <tab.icon className={`w-6 h-6 ${isActive ? 'stroke-[2.5]' : ''}`} />
                                <span className={`text-xs mt-1 ${isActive ? 'font-semibold' : 'font-medium'}`}>
                                    {tab.label}
                                </span>
                            </>
                        )}
                    </NavLink>
                ))}

                {/* Account tab */}
                {isAuthenticated && user ? (
                    <NavLink
                        to="/account"
                        className={({ isActive }) =>
                            `flex flex-col items-center justify-center flex-1 h-full py-2 transition-colors
                            ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'}`
                        }
                    >
                        {user.avatarUrl ? (
                            <img src={user.avatarUrl} alt="" className="w-6 h-6 rounded-full" />
                        ) : (
                            <User className="w-6 h-6" />
                        )}
                        <span className="text-xs mt-1 font-medium">Tài khoản</span>
                    </NavLink>
                ) : (
                    <button
                        onClick={openAuthModal}
                        className="flex flex-col items-center justify-center flex-1 h-full py-2 text-gray-500 hover:text-gray-700 transition-colors"
                    >
                        <User className="w-6 h-6" />
                        <span className="text-xs mt-1 font-medium">Đăng nhập</span>
                    </button>
                )}
            </div>
        </nav>
    );
};

export default MobileTabBar;

